// removed by extract-text-webpack-plugin
module.exports = {"link":"custom-order__link-31zhV","tools":"custom-order__tools-36hB8","controlPanel":"custom-order__controlPanel-183HD","buttonsPanel":"custom-order__buttonsPanel-2aHi5","info":"custom-order__info-2BQRV","orderButton":"custom-order__orderButton-TLJqA","reset":"custom-order__reset-SbmBN","button":"custom-order__button-4NZS4 blocks__button-1iODk blocks__mini-Jb_UB"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/custom-order.css
// module id = 815
// module chunks = 0